module.exports = __webpack_public_path__ + "img/First 100 Percent Locked.1fb1d35.png";